import { SET_ACTIVE_TAB } from '../types/tab'

const initialState = {
  activeTab: {
    applicantDetails: 'activities',
    applicantCV: 'uploadedCV',
  },
}

const tabReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: {
          ...state.activeTab,
          [action.payload.group]: action.payload.name,
        },
      }
    default:
      return state
  }
}

export default tabReducer
